import React, { useEffect, useState } from 'react';

// services
import { onGetSettingsByCategory } from 'modules/settings/services/settings';

// models
import { Setting } from 'modules/settings/models/settings';

// components
import LoadingComponent from 'components/loadingComponent/loadingComponent';
import SettingsCategoryComponent from '../settingsCategory/settingsCategory';
import { Empty } from 'antd';
import NoData from 'components/noData/noData';

interface InputProps {
	categoryId: number;
	languages: { code: string; name: string }[];
}

function SettingsCategoryTabComponent({ categoryId, languages }: InputProps) {
	const [settings, setSettings] = useState<Setting[]>([]);
	const [isSettingsLoading, setIsSettingsLoading] = useState(true);

	const getSettings = async (id: number) => {
		try {
			setIsSettingsLoading(true);

			const settingsResponse = await onGetSettingsByCategory(id);
			setSettings(settingsResponse.data.data.settings);

			setIsSettingsLoading(false);
		} catch (error) {
			setIsSettingsLoading(false);
		}
	};

	useEffect(() => {
		getSettings(categoryId);
	}, []);

	return (
		<>
			{isSettingsLoading ? (
				<LoadingComponent />
			) : (
				<div>
					{settings.length === 0 ? (
						<NoData />
					) : (
						settings.map((setting, i) => <SettingsCategoryComponent setting={setting} languages={languages} key={i} />)
					)}
				</div>
			)}
		</>
	);
}

export default React.memo(SettingsCategoryTabComponent);
